<div class='container'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Create a new user role</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-user-role-form [userGroup]='this.userGroup' [userGroupPermissions]='this.userGroupPermissions'></app-user-role-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/settings/users'>Cancel</button>
    </form>
  </div>
</div>
